import React, { Fragment, useState } from 'react'
import { Menu } from 'antd'
import FeatherIcon from 'feather-icons-react'
import { createFromIconfontCN } from '@ant-design/icons';
//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'
import './Sidebar.less'
import Icon, { MessageOutlined } from '@ant-design/icons';

const { SubMenu } = Menu

const IconFont = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_1964787_1z33meo70x9.js',
  });

function Sidebar(props) {

    const [openKeys, setOpenKeys] = useState('')
    const pathname = props.location.pathname.split('/')

    const handleOpenSub = (path) => {
        if (path !== openKeys) {
            setOpenKeys(path)
            localStorage.setItem('', path)
        } else {
            setOpenKeys('')
            localStorage.setItem('', '')
        }
    }

    const permissions = localStorage.getItem('permissions') ? JSON.parse(localStorage.getItem('permissions')).filter(permission => permission !== null) : []
    const defaultSelectedKeys = localStorage.getItem('redirect')

    return (
        <Fragment>
            <div className="logo">
                <Link to={defaultSelectedKeys}>
                    {
                        props.collapsed ? (
                            // Small Logo
                            <img style={{padding:30}} src={ require('../assets/img/icon-sidebar-small.png') } alt="DEM Logo" />
                        ) : (
                            // Big Logo
                            <img style={{padding:35}} src={ require('../assets/img/banner-dashboard.png') } alt="DEM Logo" />
                        )
                    }
                </Link>
            </div>
            <Menu
                mode="inline"
                theme="light"
                defaultSelectedKeys={defaultSelectedKeys}
                className="sidebar"
                selectedKeys={pathname}
                openKeys={[ localStorage.getItem('openKeys') ? localStorage.getItem('openKeys') : openKeys ]}
            >
                {
                    permissions && permissions.length > 0 && permissions.map(permission => {
                        return ( permission.children && permission.children.length > 0 ? (
                            <SubMenu
                                key={permission.url}
                                onTitleClick={() => handleOpenSub(permission.url)}
                                title={
                                    <span>
                                    {/* <FontAwesomeIcon prefix="fab" icon="500px" /> */}
                                        {/* <FeatherIcon icon="close" /> */}
                                        <IconFont style={{fontSize:20}} type={permission.icon} />
                                            <span>{permission.name}</span>
                                    </span>
                                }>
                                    {
                                        permission.children && permission.children.map(child => {
                                            return child && (
                                                <Menu.Item
                                                    key={child.url}
                                                    >
                                                        <Link to={`/${child.url}`}>{child.name}</Link>
                                                </Menu.Item>
                                            )
                                        })
                                    }
                                </SubMenu>
                                
                            ) : (
                                <Menu.Item
                                    key={permission.url}
                                    >
                                        <Link to={`/${permission.url}`}>
                                            {/* <Icon type="message" theme="outlined" /> */}
                                            {/* <MessageOutlined />  */}
                                            <IconFont style={{fontSize:20}} type={permission.icon} />

                                            <span>{permission.name}</span>
                                        </Link>
                                </Menu.Item>
                            )
                        )
                    })
                }
               
            </Menu>
        </Fragment>
    )
}

export default Sidebar
